export const Svg_078 = () => (
  <svg style={{ width: '70px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70" >
    <defs>
      <linearGradient
        id="a"
        x1={47.3}
        x2={16.1}
        y1={11.7}
        y2={56.3}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M60.1 47.7c0 2.2-1.3 4.2-3.3 5l-12.2 5.4c-.6.3-1.3.4-2 .4H11.5c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h31.1c.2 0 .5 0 .7-.1l12.2-5.4c.8-.3 1.3-1.1 1.3-2s-1-2.2-2.2-2.2-.6 0-.9.2l-9 4c-.6.3-1.3.4-2 .4H30c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h8.4c.9 0 1.7-.8 1.7-1.7s-.8-1.7-1.7-1.7h-12c-.4 0-.9.2-1.2.5l-3.1 3.1c-.9 1-2.2 1.5-3.6 1.5h-7c-.9 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7h7c.4 0 .9-.2 1.2-.5l3.1-3.1c.9-1 2.2-1.5 3.5-1.5h12c2.8 0 5 2.2 5 5s0 1.1-.3 1.6h.2l9-4c2.8-1.2 6 0 7.3 2.8.3.7.5 1.5.5 2.2Zm-41-31.9c0-.9 0-1.7.2-2.6.1-.7.7-1.2 1.4-1.3.9-.2 1.7-.2 2.6-.2 7.4 0 13.4 6 13.4 13.4v10.1c0 .9-.8 1.7-1.7 1.7s-1.7-.8-1.7-1.7v-5.9h-.8c-7.4 0-13.4-6-13.4-13.4Zm3.3 0c0 5.6 4.5 10.1 10 10.1h.8v-.8c0-5.6-4.5-10.1-10.1-10.1h-.8v.8ZM39.5 18c1.9-1.9 4.5-3 7.2-3h.8v.8c0 4.7-3.3 8.8-7.9 9.8-.9.2-1.5 1.1-1.3 2s1.1 1.5 2 1.3c6.1-1.4 10.5-6.8 10.5-13.1 0-.9 0-1.7-.2-2.6-.1-.7-.7-1.2-1.3-1.3-.9-.2-1.7-.2-2.6-.2-3.6 0-7.1 1.4-9.6 4-.6.7-.6 1.7 0 2.4s1.7.6 2.4 0Z"
      style={{
        fill: "url(#a)",
      }}
    />
  </svg>
)